export default "__VITE_ASSET__DBp8tmxv__"